import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Checkbox as DefaultCheckbox } from '~/components/blocks';
import { patientPageInfoState } from '~/state/patient/atoms';

const Checkbox = styled(DefaultCheckbox)(({ theme }) =>
  css({
    fontSize: theme.fontSizes.m,
    fontWeight: theme.fontWeights.bold,
  }),
);

export const FollowingUpCheckBox = () => {
  const [{ isFollowingUp }, setState] = useAtom(patientPageInfoState);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setState((_state) => ({
        ..._state,
        isFollowingUp: e.currentTarget.checked || null,
        page: 1,
      }));
    },
    [setState],
  );

  return <Checkbox label="対応中" checked={!!isFollowingUp} onChange={handleChange} />;
};
